import React from "react";
import inputsValidation from "../../messages/inputValidation";
import "../../style/forms.scss";
import "../../style/alerts.scss";

interface IProps {
  type: string;
  name: string;
  text: string;
  isLabel?: boolean;
  register: any;
  errors: any;
  defaultValue?: any;
}

const FormInputReadOnly: React.FC<IProps> = ({ name, text, isLabel = false, type, register, errors, defaultValue }: IProps) => {
  return (
    <div className="form" id={`input-${name}`}>
      {/* {isLabel && <label>{text}</label>} */}
      <input type={type} placeholder={text} {...register} defaultValue={defaultValue} readOnly/>
      {errors[name] && <div className="alert alert-red">*{inputsValidation(errors, name)}</div>}
    </div>
  );
};

export default FormInputReadOnly;
